import React, { createContext, useContext, useEffect } from "react";
import { createPortal } from "react-dom";

// Pages portal their toolbar into the shell slot; isolated renders fall back to inline content.
type ToolbarContextValue = { slot: HTMLElement | null; setStickyOnMobile: (v: boolean) => void };
export const RedesignToolbarContext = createContext<ToolbarContextValue>({ slot: null, setStickyOnMobile: () => {} });

export function RedesignPageToolbar({ children, sticky = true, stickyOnMobile = false }: { children: React.ReactNode; sticky?: boolean; stickyOnMobile?: boolean }) {
  const { slot, setStickyOnMobile } = useContext(RedesignToolbarContext);
  useEffect(() => {
    if (!sticky) return;
    setStickyOnMobile(stickyOnMobile);
    return () => setStickyOnMobile(false);
  }, [sticky, stickyOnMobile, setStickyOnMobile]);

  if (!sticky || !slot) return <>{children}</>;
  return createPortal(children, slot);
}
